var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExercicios(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_235_335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1482 0.00342815C9.74339 0.215365 7.96884 1.4157 6.93437 3.15096C6.24109 4.02005 4.85622 6.67338 4.35257 8.06237C3.43935 9.78963 2.64301 11.8447 2.01981 13.6974C1.63886 14.8303 3.34939 15.5694 3.73252 14.4314C4.19859 13.0453 4.76165 11.5467 5.39795 10.156C6.02939 11.5693 6.67103 12.9779 7.35994 14.3642C7.89391 15.4404 9.50065 14.4966 8.96863 13.4241C8.25934 11.997 7.60049 10.5472 6.95135 9.09247C6.95959 9.06434 6.97002 9.03694 6.97875 9.00906C7.0869 9.03985 7.2062 9.04931 7.33763 9.02433C8.33088 8.83786 9.32412 8.65187 10.3181 8.46539C10.7427 8.38561 10.9054 7.921 10.8385 7.54902C10.6377 6.43429 10.0026 5.6588 9.21209 4.92502C9.09472 4.52588 8.70334 4.17282 8.26904 3.82193C9.14952 2.39851 10.587 1.62593 12.4581 1.46104C13.413 1.37738 13.0949 -0.0797462 12.1482 0.00342815ZM8.52923 6.33947C8.77488 6.59506 8.9839 6.86398 9.14177 7.17534C8.66115 7.26555 8.18029 7.35551 7.69967 7.44572C7.94216 7.05531 8.22127 6.68672 8.52923 6.33947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5858 5.07048C11.2922 5.07048 11.8649 4.49779 11.8649 3.79135C11.8649 3.0849 11.2922 2.51221 10.5858 2.51221C9.87933 2.51221 9.30664 3.0849 9.30664 3.79135C9.30664 4.49779 9.87933 5.07048 10.5858 5.07048Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_235_335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExercicios);
export default __webpack_public_path__ + "static/media/exercicios.e541fefe68aedacfdc9b693cb375894f.svg";
export { ForwardRef as ReactComponent };